import React from "react";
import styled from "styled-components";
import Dropdown from 'react-bootstrap/Dropdown';
import classNames from "classnames";
import { useDropdownContext } from "./DropdownContext";
import OptionDropdown from "./OptionDropdown";

interface IDropdownMenuProps {
    title?: string;
    className?: string;
    visibleItems: string;
    children;
}

export default styled((props: IDropdownMenuProps) => {
    const { selectedItem } = useDropdownContext();

    return (
        <Dropdown.Menu bsPrefix='custom-dropdown-menu' className={classNames(props.className, 'px-3 pt-2 pb-4')}>
            <OptionDropdown text={selectedItem?.text} isPlaceholder={true} eventKey={selectedItem?.eventKey} html={selectedItem?.html}/>
            {props.title ? <div className="custom-dropdown-menu_title">{props.title}</div> : null}
            <div className="w-100 overflow-auto custom-dropdown-menu_items">
                {props.children}
            </div>
        </Dropdown.Menu>
    );
})<{ visibleItems: number }>`
z-index: 4;

.custom-dropdown-menu_title {
    color: #000;
    margin-bottom: 10px;
    font-family: "National2 Narrow";
    font-size: 0.88889rem;
    font-weight: 700;
    line-height: 1.55556rem;
    letter-spacing: 0.02667rem;
    text-transform: uppercase;
    opacity: 0.25;
}

.custom-dropdown-menu_items {
    max-height: ${({visibleItems = 0}) => visibleItems > 0 ? `${(visibleItems * 34) - 12}px` : 'none'}; // Each item is 34px tall with a 12px offset from the gap between
    height: 100%;
    @media (max-width:992px) {
        max-height: none;
        height: 100%;
    }
}
`;